/* ==============================================================
   Mana.jam — Barra de progresso de frete grátis (PDP)
   Web component <manajam-free-shipping-bar>.
   Enche conforme o subtotal do carrinho. Atualiza ao vivo via o
   pub/sub `cartUpdate` do tema (mesmo evento usado pelo cart.js).
   ============================================================== */
(function () {
  if (window.customElements.get('manajam-free-shipping-bar')) return;

  // formatMoney padrão da Shopify (suporta os tokens de money_format)
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var fmt = format || '${{amount}}';
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;

    function fmtNumber(number, precision, thousands, decimal) {
      precision = isNaN(precision) ? 2 : precision;
      thousands = thousands == null ? ',' : thousands;
      decimal = decimal == null ? '.' : decimal;
      if (isNaN(number) || number == null) return '0';
      number = (number / 100).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsPart = parts[1] ? decimal + parts[1] : '';
      return dollars + centsPart;
    }

    var value = '';
    var match = fmt.match(placeholder);
    var token = match ? match[1] : 'amount';
    switch (token) {
      case 'amount': value = fmtNumber(cents, 2); break;
      case 'amount_no_decimals': value = fmtNumber(cents, 0); break;
      case 'amount_with_comma_separator': value = fmtNumber(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = fmtNumber(cents, 0, '.', ','); break;
      case 'amount_with_space_separator': value = fmtNumber(cents, 2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': value = fmtNumber(cents, 0, ' ', ''); break;
      case 'amount_with_apostrophe_separator': value = fmtNumber(cents, 2, "'", '.'); break;
      default: value = fmtNumber(cents, 2);
    }
    return fmt.replace(placeholder, value);
  }

  class ManajamFreeShippingBar extends HTMLElement {
    connectedCallback() {
      this.threshold = parseInt(this.dataset.threshold, 10) || 0;
      this.moneyFormat = this.dataset.moneyFormat || '${{amount}}';
      this.msgProgress = this.dataset.msgProgress || 'Faltam [amount] para o frete grátis';
      this.msgSuccess = this.dataset.msgSuccess || 'Você ganhou frete grátis!';

      // metas em ordem crescente, cada uma com sua mensagem de progresso.
      // Sem data-threshold2 a lista tem 1 item e o comportamento é o original.
      var milestones = [];
      if (this.threshold > 0) milestones.push({ cents: this.threshold, msgProgress: this.msgProgress });
      var threshold2 = parseInt(this.dataset.threshold2, 10) || 0;
      if (threshold2 > 0) milestones.push({ cents: threshold2, msgProgress: this.dataset.msg2Progress || this.msgProgress });
      milestones.sort(function (a, b) { return a.cents - b.cents; });
      this.milestones = milestones;
      this.maxCents = milestones.length ? milestones[milestones.length - 1].cents : 0;
      this.msgAllSuccess = this.dataset.msgAllSuccess || this.msgSuccess;

      this.hideWhenEmpty = this.dataset.hideWhenEmpty === 'true';
      this.celebrateEnabled = this.dataset.celebrate === 'true';
      this.barId = this.dataset.barId || 'default';
      this.textEl = this.querySelector('[data-fsb-text]');
      this.fillEl = this.querySelector('[data-fsb-fill]');

      // pinta o estado inicial vindo do servidor (rápido), depois confirma com o cart real
      this.render(parseInt(this.dataset.current, 10) || 0);
      this.fetchAndRender();

      this.onCartUpdate = this.onCartUpdate.bind(this);
      this.onRefresh = this.fetchAndRender.bind(this);
      if (window.MinimogEvents && window.MinimogTheme && window.MinimogTheme.pubSubEvents) {
        this._unsub = window.MinimogEvents.subscribe(
          window.MinimogTheme.pubSubEvents.cartUpdate,
          this.onCartUpdate
        );
      }
      document.addEventListener('cart:refresh', this.onRefresh);
    }

    disconnectedCallback() {
      if (this._unsub) this._unsub();
      document.removeEventListener('cart:refresh', this.onRefresh);
    }

    onCartUpdate(payload) {
      var cart = payload && payload.cart;
      if (cart && typeof cart.total_price === 'number' && Array.isArray(cart.items)) {
        this.render(cart.total_price);
      } else {
        this.fetchAndRender();
      }
    }

    fetchAndRender() {
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then((cart) => { this.render(cart.total_price); })
        .catch(function () {});
    }

    // Monta o texto sem innerHTML: nós de texto + <strong> para o valor.
    // successText preenchido = estado final; senão usa progressTemplate com [amount].
    setMessage(successText, remaining, progressTemplate) {
      if (!this.textEl) return;
      this.textEl.textContent = '';
      if (successText) {
        this.textEl.textContent = successText;
        return;
      }
      var parts = (progressTemplate || this.msgProgress).split('[amount]');
      var strong = document.createElement('strong');
      strong.textContent = formatMoney(remaining, this.moneyFormat);
      this.textEl.appendChild(document.createTextNode(parts[0] || ''));
      this.textEl.appendChild(strong);
      this.textEl.appendChild(document.createTextNode(parts.slice(1).join('[amount]') || ''));
    }

    render(totalCents) {
      if (!this.milestones.length) return;
      var pct = Math.min(100, (totalCents / this.maxCents) * 100);

      // próxima meta não atingida (lista já está ordenada por valor)
      var next = null;
      var reachedCount = 0;
      for (var i = 0; i < this.milestones.length; i++) {
        if (totalCents >= this.milestones[i].cents) reachedCount++;
        else { next = this.milestones[i]; break; }
      }
      var allReached = !next;

      if (this.fillEl) this.fillEl.style.width = pct + '%';
      this.classList.toggle('manajam-fsb--reached', allReached);
      if (allReached) {
        this.setMessage(this.msgAllSuccess, 0, null);
      } else {
        this.setMessage(null, next.cents - totalCents, next.msgProgress);
      }

      // celebração: a cada meta NOVA atingida (contagem sobe). O estado anterior
      // vive num global por barId porque o elemento da gaveta é destruído e
      // recriado a cada re-render do carrinho (innerHTML do header é substituído).
      var store = (window.__mnjFsbReached = window.__mnjFsbReached || {});
      var prev = store[this.barId];
      if (prev === true) prev = 1; // formato antigo (booleano) de sessões passadas
      if (prev === false) prev = 0;
      store[this.barId] = reachedCount;
      if (typeof prev === 'number' && reachedCount > prev && this.celebrateEnabled) this.celebrate();

      if (this.hideWhenEmpty) this.hidden = totalCents <= 0;
    }

    celebrate() {
      this.classList.add('manajam-fsb--celebrate');
      clearTimeout(this._celebrateTimer);
      this._celebrateTimer = setTimeout(() => {
        this.classList.remove('manajam-fsb--celebrate');
      }, 2600);
    }
  }

  window.customElements.define('manajam-free-shipping-bar', ManajamFreeShippingBar);
})();
